import { render, staticRenderFns } from "./FaqComponent.vue?vue&type=template&id=67f0c79b&scoped=true&"
import script from "./FaqComponent.vue?vue&type=script&lang=js&"
export * from "./FaqComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0c79b",
  null
  
)

export default component.exports